import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import moment from 'moment';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { FocuslinkService } from './focuslink.service';
import { LocalDataStoreService } from './local-data-store.service';

@Injectable({
	providedIn: 'root',
})
export class DeviceService {
	connectionVenueKey: number;
	socket: WebSocketSubject<any> = webSocket(environment.production ? 'wss://ws.focuslink.focuspos.com/' : 'wss://dev.ws.focuslink.focuspos.com/');
	licenseKey: string;
	licenseSecret: string;

	constructor(private focuslink: FocuslinkService, private localStorage: LocalDataStoreService) {}

	async storeLicense(licenseKey: string, licenseSecret: string) {
		await this.localStorage.set('kioskDeviceId', licenseKey);
		await this.localStorage.set('kioskLicenseSecret', licenseSecret);
		this.licenseKey = licenseKey;
		this.licenseSecret = licenseSecret;
	}

	async verifyLicense(licenseKey: string, licenseSecret: string): Promise<boolean> {
		if (!licenseKey || !licenseSecret) {
			return false;
		}

		const signature = `${this.generateHash(licenseKey, licenseSecret)}:${moment().valueOf()}:${uuidv4()}`;

		try {
			const validLicense = await this.focuslink.licenseVerify(licenseKey, signature, '1.0');
			if (validLicense === 'invalid') {
				return false;
			}
			this.licenseKey = licenseKey;
			this.licenseSecret = licenseSecret;
			return true;
		} catch (error) {
			console.log(error);
			return false;
		}
	}

	async connect(venueKey: number) {
		const registrationMessage = {
			action: 'registerDevice',
			key: this.licenseKey,
			signature: this.flGenerateSignature(this.licenseKey, this.licenseSecret),
			venueKey: venueKey,
			request: {
				requestContext: {
					domainName: environment.production ? `app.focuspos.com` : `dev.onlineorder.focuspos.com`,
				},
				path: '/v2/licenses/verify',
			},
		};

		console.log(`Connecting to Device WS`);
		console.log(registrationMessage);
		const res = await this.socket.next(registrationMessage);
		this.connectionVenueKey = venueKey;
		console.log(`Connected to Device WS`);
	}

	async awaitMessage() {
		this.socket.subscribe((message) => {
			//do something with message
		});
	}

	async disconnect(venueKey: number, newVenueKey?: number) {
		this.connectionVenueKey = 0;

		const res = await this.socket.next({
			action: 'deregisterDevice',
			key: this.licenseKey,
			venueKey: venueKey,
		});
	}

	flGenerateSignature(licenseKey: string, licenseSecret: string) {
		const domain = environment.production ? `app.focuspos.com` : `dev.onlineorder.focuspos.com`;

		const timestamp = moment().valueOf(); // UTC time in milliseconds since the Unix epoch
		const nonce = uuidv4();

		const url = `${domain}/v2/licenses/verify`;

		const sigRawData = `${licenseKey}:POST:${url}:${timestamp}:${nonce}`;
		const signature = this.generateHash(sigRawData, licenseSecret);
		const clientSignature = `${signature}:${timestamp}:${nonce}`;
		return clientSignature;
	}

	generateHash(message: string, secret: string): string {
		const hash = crypto.HmacSHA256(message, secret);
		const b64Hash = crypto.enc.Base64.stringify(hash);
		return b64Hash;
	}
}
